import { createClient } from "next-sanity";

import { apiVersion, dataset, projectId, useCdn } from "../env";

export const client = () => {
  return createClient({
    apiVersion,
    dataset,
    projectId,
    useCdn,
    perspective: "published",
  });
};
